document.addEventListener('DOMContentLoaded', function () {
    const carouselTrack = document.getElementById('carousel-track');
    const modalCarouselTrack = document.getElementById('modal-carousel-track');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    const modalPrev = document.getElementById('modalPrev');
    const modalNext = document.getElementById('modalNext');

    const modal = document.getElementById('zoomModal');
    const openZoom = document.getElementById('openZoom');
    const closeZoom = document.getElementById('closeZoom');

    const slideCount = carouselTrack?.children.length || 0;
    let currentSlide = 0;
    let startX = 0;
    let endX = 0;

    function updateSlidePosition(trackEl, index) {
      const offset = -index * 100;
      trackEl.style.transform = `translateX(${offset}%)`;
    }

    function updateNavButtons(index, total, prev, next) {
      prev.disabled = index === 0;
      next.disabled = index === total - 1;

      [prev, next].forEach((btn) => {
        btn.classList.toggle('opacity-50', btn.disabled);
      });
    }

    function renderMain() {
       if (slideCount <= 1) {
    prevBtn?.classList.add('hidden');
    nextBtn?.classList.add('hidden');
    return;
  }
      updateSlidePosition(carouselTrack, currentSlide);
      updateNavButtons(currentSlide, slideCount, prevBtn, nextBtn);
    }

    function renderModal() {
       if (slideCount <= 1) {
    modalPrev?.classList.add('hidden');
    modalNext?.classList.add('hidden');
    return;
  }
      updateSlidePosition(modalCarouselTrack, currentSlide);
      updateNavButtons(currentSlide, slideCount, modalPrev, modalNext);
    }

    function attachTouchEvents(track, updateSlide) {
      track?.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      track?.addEventListener('touchmove', (e) => {
        endX = e.touches[0].clientX;
      });

      track?.addEventListener('touchend', () => {
        const diff = endX - startX;
        if (Math.abs(diff) > 50) {
          if (diff < 0 && currentSlide < slideCount - 1) {
            currentSlide++;
          } else if (diff > 0 && currentSlide > 0) {
            currentSlide--;
          }
          updateSlide();
        }
      });
    }

    // Buttons - main
    prevBtn?.addEventListener('click', () => {
      if (currentSlide > 0) currentSlide--;
      renderMain();
    });

    nextBtn?.addEventListener('click', () => {
      if (currentSlide < slideCount - 1) currentSlide++;
      renderMain();
    });

    // Buttons - modal
    modalPrev?.addEventListener('click', () => {
      if (currentSlide > 0) currentSlide--;
      renderModal();
    });

    modalNext?.addEventListener('click', () => {
      if (currentSlide < slideCount - 1) currentSlide++;
      renderModal();
    });

    // Zoom modal open/close
    openZoom?.addEventListener('click', () => {
      modal?.classList.remove('hidden');
      renderModal();
    });

    closeZoom?.addEventListener('click', () => {
      modal?.classList.add('hidden');
    });

    // Attach swipe support
    attachTouchEvents(carouselTrack, renderMain);
    attachTouchEvents(modalCarouselTrack, renderModal);

    // Initial render
    renderMain();
  });